<script setup lang="ts">
  import MobilePrimaryButton from '@/shared/ui/MobilePrimaryButton.vue';
  import { useMobileSearchFlowContext } from '../../../model/useMobileSearchFlow';
  import MobileSearchFields from '../MobileSearchFields.vue';

  const flow = useMobileSearchFlowContext();
</script>

<template>
  <div
    class="mobile-main-screen"
    data-testid="search-form-mobile-main"
  >
    <slot name="header" />

    <div class="mobile-main-screen__sheet">
      <MobileSearchFields class="mobile-main-screen__fields" />
      <div class="mobile-main-screen__container-buttons">
        <slot name="button-prepend"></slot>
        <MobilePrimaryButton
          testid="search-form-mobile-primary"
          @click="flow.submit"
        >
          {{ flow.primaryTexts.searchBtn }}
        </MobilePrimaryButton>
      </div>
      <slot name="footer" />
    </div>

    <slot name="pageFooter" />
  </div>
</template>

<style lang="scss" scoped>
  .mobile-main-screen {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;

    &__sheet {
      background: var(--color-slate-10);
      border-radius: 24px 24px 0 0;
      box-sizing: border-box;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      padding: var(--spacing-l) var(--spacing-m) var(--spacing-xxl);
      width: 100%;
    }

    &__container-buttons {
      display: flex;
      gap: var(--spacing-xs);
      margin-top: var(--spacing-m);
    }
  }
</style>
